export default __webpack_public_path__ + "static/media/ai_virtual_services_generated_photos_en.3861fb0d.png";